import { SMART_T_STEP } from "libs/constant/Step";

export const getChangeSmartTitleByType = (ConditionType) => {
  switch (ConditionType) {
    case "CO":
      return "Changing of a position, job title, responsibility or assignment within the same company.";
    case "AE":
      return "Additional employment (working for another endorsed company, employer or sponsor).";
    case "AC":
      return "Additional companies in which Smart I and S holder invests in.";
    case "CA":
      return "Changing of company  address under the same juristic ID.";
    case "CN":
      return "Changing of company name under the same juristic ID.";
    case "DD":
      return "Divestment or decreasing shareholding.";
    default:
      return "";
  }
};

export const getRouterChangeSmartByConditionType = (ConditionType) => {
  switch (ConditionType) {
    case "CO":
      return [
        SMART_T_STEP.NONE,
        SMART_T_STEP.UPDATE_JOB_POSITION,
        SMART_T_STEP.UPLOAD_DOCUMENT,
      ];
    case "AE":
      return [
        SMART_T_STEP.NONE,
        SMART_T_STEP.ADD_JOB_POSITION,
        SMART_T_STEP.UPLOAD_DOCUMENT,
      ];
    case "AC":
      return [
        SMART_T_STEP.NONE,
        SMART_T_STEP.ADD_COMPAMY_INVESTMENT,
        SMART_T_STEP.UPLOAD_DOCUMENT,
      ];
    case "CA":
      return [SMART_T_STEP.NONE, SMART_T_STEP.UPDATE_COMPANY_INFO];
    case "CN":
      return [SMART_T_STEP.NONE, SMART_T_STEP.UPDATE_COMPANY_INFO];
    case "DD":
      return [SMART_T_STEP.NONE, SMART_T_STEP.UPDATE_COMPANY_INFO];
    default:
      return [SMART_T_STEP.NONE];
  }
};
